import React, { useState } from "react";
import "../../App.css";
import { BASE_DOMAIN } from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./MdaTrack.module.css";

const MdaTrackTicket = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const param = state && state.param;
  const email = state && state.param2;
  const ticketId = state && state.ticketId;
  const trackForm = state && state.param1;
  

  const [selectedOption, setSelectedOption] = useState(param);

    const goBack = () => {
      navigate(-1);
    };

  if (!selectedOption) {
    // Handle if selectedOption is undefined
    return <div>No selected option</div>; 
  }

  return (
    <div className="track-container">
      {trackForm === "trackForm" && (
        <div className={styles.goBack} onClick={goBack}>
          <img
            src="https://res.cloudinary.com/dso7hgghd/image/upload/v1705918242/back_no6tw3.png"
            width={26}
            alt="Go back"
            onClick={goBack}
          />{" "}
          <span className={styles.backText}>Inter MDA Track Task</span>
        </div>
      )}
      <div style={{ display: "flex" }}>
        <iframe
          id="myIframe"
          title="Embedded Content"
          width="1000"
          height="800"
          src={`https://${selectedOption.tenantId}.${BASE_DOMAIN}/ticket-tracker/tracking?ticketID=${ticketId}&email=${email}&displayHeader=${true}`}
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default MdaTrackTicket; 
